<template>
  <div class="flex items-center relative">
    <span class="absolute left-0 ml-2">
      <i v-if="success" class="fas fa-check text-ok-fam-green"></i>
      <i v-else-if="error" class="fas fa-times text-warning-red"></i>
      <i v-else-if="loading" class="fas fa-circle-notch fa-spin"></i>
      <i v-else class="fas fa-tags"></i>
    </span>
    <input
      type="text"
      v-model="couponString"
      placeholder="Enter Coupon Code Here"
      @keyup.enter="apply"
    >
    <a
      @click="apply"
      :class="['absolute right-0 mr-2 text-sm', canApply ? 'text-smurfs-gold cursor-pointer' : 'text-50']"
    >Apply</a>
  </div>
</template>

<script>
import { applyCouponMixin } from '../../shared/mixins/applyCouponMixin';
export default {
  mixins: [applyCouponMixin],
};
</script>

<style lang="scss" scoped>
input {
  @apply flex-1;
  @apply border-t border-b border-50;
  @apply bg-transparent text-absolute-white;
  @apply py-3 pl-10;
  @apply outline-none;

  &::placeholder {
    @apply font-normal text-50;
  }
}
</style>
